module.exports = __webpack_public_path__ + "static/media/af19.72fa598a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/af19.jpg
// module id = 171
// module chunks = 0